import React, { Component } from "react";
import User from "./User";
import Tasks from "./Tasks";
import Task from "./Task";
import RegistrationLink from "./RegistrationLink";

class Single extends Component {
  render() {
    const { match, users } = this.props;
    const id = Number(match.params.id);
    const user = users.find((user) => user.id === id);
    const tasks = this.props.tasks[match.params.id] || [];
    const index = this.props.users.findIndex((user) => user.id === id);
    if (this.props.auth.authenticated === false) {
      return <RegistrationLink />;
    }
    if (this.props.loading === true) {
      return <div className="loader">loading...</div>;
    } else if (user) {
      return (
        <div className="single-photo">
          {/*<User user={user} {...this.props} index={index}></User>*/}
          <Tasks
            startAddingTask={this.props.startAddingTask}
            startLoadingTasks={this.props.startLoadingTasks}
            startRemovingTask={this.props.startRemovingTask}
            startClosingTask={this.props.startClosingTask}
            filters={this.props.filters}
            setTaskFilter={this.props.setTaskFilter}
            setStatusFilter={this.props.setStatusFilter}
            tasks={tasks}
            id={id}
            users={users}
            loading={this.props.loading}
          />
        </div>
      );
    } else {
      return <h1>No Post Found</h1>;
    }
  }
}

export default Single;
